// Floria visual-identity tokens — feature 290-floria-backfill, US3 (FR-058).
//
// Light-sage palette. Pressed is the hover/active state for the launcher.
// Per-kind icon colors and priority dot/pill colors are deliberately
// untouched (FR-058 last clause).
//
// Contrast (white text against the relevant stop):
//   accent.primary  3.42:1  → WCAG AA large text (label is 14px bold which
//                              qualifies); `graphical objects` 3:1 also met
//   accent.soft     1.55:1  → decorative gradient end only, no text on it
//   accent.pressed  4.79:1  → WCAG AA normal text
export const FLORIA_TOKENS = {
  accent: {
    primary: '#6b9676',
    soft: '#bcd9c2',
    pressed: '#4a7c59',
  },
  // Companion RGB triplets for buddy halo, drop-shadow, and launcher overlay
  // alpha values without a color-mix() polyfill.
  accentRgb: {
    primary: '107, 150, 118',
    pressed: '74, 124, 89',
  },
} as const

export const FLORIA_HEADER_GRADIENT = `linear-gradient(135deg, ${FLORIA_TOKENS.accent.primary}, ${FLORIA_TOKENS.accent.soft})`
